import React from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import '../css/bootstrap.css';
import '../css/dashboard.css';
import '../css/gestion-pacientes.css';
import Logo from '../logo.jpg';
import Loading from '../loading.gif';
import PerfilPaciente from './perfil_paciente';
import AgregarCita from './agregar_cita';
import Url from './funciones_extras';
import ActualizarPerfil from './actualizar_paciente';
import ImgPerfil from '../usuario.png';
import ImgAsignar from '../asignar.png';
import ImgActualizar from '../actualizar.png'
import alertify from 'alertifyjs';
import { Doughnut,Bar} from 'react-chartjs-2';
import Paginador from './Paginador';

const REGISTROS_POR_PAGINA = 8;

class  Cita extends React.Component{

	constructor(props){
		super(props);
		this.id_paciente=0;
		this.state ={perfil_selec:false,
					id_doctor:0,
					nombre_paciente:"",
					procedimientos_hechos:0,
					foto_paciente:"",
					clientes:[
						  
					    ],
						id_paciente:0,
						estado_busqueda:"paciente_por_nombre",
						generos:[{hombres:0},{mujeres:0}],
						cantidad_de_pacientes:0,
						meses:new Array ("enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"),
						paginaActual: 1,
						ultimaPagina: 1,
						totalPacientes: 0,
						enBusqueda: false,
						clientesBusqueda: [],
						cargandoPacientes: false,
						todosPacientes: [],
						paginacionCliente: false,
						terminoBusqueda: '',
						fotosFallidas: {},
						exportandoCsv: false
					};
	}
	




	componentDidMount(){
		
		this.cargar_citas();
		//this.Cargar_generos_paciente();
		this.Procedimientos_realizados();
		this.cargar_cantidad_de_pacientes();
	}
	
	dia_actual(){

		var f=new Date();
		var dia="";
		dia= f.getDate() + " de " + this.state.meses[f.getMonth()] + " de " + f.getFullYear();
		return dia;
	}


	 Cargar_generos_paciente=()=>{
    

    
			Axios.get(`${Url.url_base}/api/cargar_generos_pacientes`).then(data=>{
				this.setState({generos:data.data});
				
			}).catch(error=>{

					console.log("error cargando genero de pacientes");
			});


	}

	Procedimientos_realizados=()=>{

		Axios.get(`${Url.url_base}/api/procedimientos_realizados`).then(data=>{

			this.setState({
				procedimientos_hechos:data.data
				
			});

		}).catch(error=>{

			alertify.message("UPS error cargando procedimientos realizados");
		});	


	}


	CheckSeleccion=()=>{

		let busqueda = document.getElementById("select_busqueda").value;
		
	
		if(busqueda=="paciente_por_nombre"){

			alertify.message("Has seleccionado búsqueda por nombre");
			this.setState({estado_busqueda:"paciente_por_nombre"});


		}else if(busqueda=="paciente_por_telefono"){
			
			alertify.message("Has seleccionado búsqueda por teléfono");
			this.setState({estado_busqueda:"paciente_por_telefono"});

		}else if(busqueda=="paciente_por_procedimiento"){

			alertify.message("Has seleccionado búsqueda por procedimiento");
			this.setState({estado_busqueda:"paciente_por_procedimiento"});

		}else if(busqueda=="paciente_por_apellido"){

			alertify.message("Has seleccionado búsqueda por apellido");
			this.setState({estado_busqueda:"paciente_por_apellido"});
		
		}else{

			alertify.message("Has seleccionado búsqueda por cedula");
			this.setState({estado_busqueda:"paciente_por_cedula"});

		}

		

	}


	normalizarPacientes = (lista) => {
		return (lista || []).map((paciente) => {
			if (paciente.doctor == null) {
				return {
					...paciente,
					doctor: {
						id: 1,
						nombre: "No tiene",
						apellido: "doctor registrado",
						dni: "000-00000-0",
						numero_telefono: "000,000,000",
						created_at: "2022-09-06 13:48:48",
						updated_at: "2022-09-06 13:48:48",
					}
				};
			}
			return paciente;
		});
	}

	getPacientesVisibles = () => {
		if (this.state.enBusqueda) {
			const inicio = (this.state.paginaActual - 1) * REGISTROS_POR_PAGINA;
			return this.state.clientesBusqueda.slice(inicio, inicio + REGISTROS_POR_PAGINA);
		}
		return this.state.clientes;
	}

	exportarCsv = () => {
		if (!Url.puedeExportarPacientesCsv()) {
			alertify.error('No tiene permiso para exportar pacientes.');
			return;
		}
		if (this.state.exportandoCsv) return;
		this.setState({ exportandoCsv: true });
		Url.exportar_pacientes_csv()
			.then((result) => {
				alertify.success(`${result.total} pacientes exportados a ${result.filename}`);
			})
			.catch((error) => {
				if (error && (error.message === 'cancelado' || error.message === 'sin_permiso')) return;
			})
			.finally(() => {
				this.setState({ exportandoCsv: false });
			});
	}

	irAPagina = (pagina) => {
		if (pagina < 1 || pagina > this.state.ultimaPagina) {
			return;
		}
		if (this.state.enBusqueda) {
			this.setState({ paginaActual: pagina });
			return;
		}
		if (this.state.paginacionCliente) {
			const inicio = (pagina - 1) * REGISTROS_POR_PAGINA;
			this.setState({
				paginaActual: pagina,
				clientes: this.state.todosPacientes.slice(inicio, inicio + REGISTROS_POR_PAGINA)
			});
			return;
		}
		this.cargar_citas(pagina);
	}

	aplicarPaginaCliente = (todos, pagina) => {
		const lista = this.normalizarPacientes(todos);
		const ultimaPagina = Math.max(1, Math.ceil(lista.length / REGISTROS_POR_PAGINA));
		const paginaSegura = Math.min(Math.max(1, pagina), ultimaPagina);
		const inicio = (paginaSegura - 1) * REGISTROS_POR_PAGINA;
		return {
			todosPacientes: lista,
			clientes: lista.slice(inicio, inicio + REGISTROS_POR_PAGINA),
			paginaActual: paginaSegura,
			ultimaPagina,
			totalPacientes: lista.length,
			paginacionCliente: true
		};
	}

	cargar_citas = (pagina = 1) => {
		this.setState({ cargandoPacientes: true });

		const config = {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('token'),
				'content-type': 'application/json'
			}
		};

		Axios.get(
			`${Url.url_base}/api/paciente?page=${pagina}&per_page=${REGISTROS_POR_PAGINA}`,
			config
		).then(res => {
			const body = res.data;

			if (Array.isArray(body)) {
				this.setState({
					...this.aplicarPaginaCliente(body, pagina),
					enBusqueda: false,
					clientesBusqueda: [],
					cargandoPacientes: false
				});
				return;
			}

			const lista = body.data || [];
			const elementos_nuevos = this.normalizarPacientes(lista);
			const tieneMeta = body.last_page != null && body.total != null;

			this.setState({
				clientes: elementos_nuevos,
				todosPacientes: [],
				paginacionCliente: false,
				enBusqueda: false,
				clientesBusqueda: [],
				paginaActual: body.current_page || pagina,
				ultimaPagina: tieneMeta ? body.last_page : Math.max(1, Math.ceil(elementos_nuevos.length / REGISTROS_POR_PAGINA)),
				totalPacientes: tieneMeta ? body.total : elementos_nuevos.length,
				cargandoPacientes: false
			});
		}).catch(error => {
			console.log(error);
			this.setState({ cargandoPacientes: false });
		});
	}

	asignar_cita=(id,nombre)=>{

		this.setState({perfil_selec:'agregar_citas',id_cliente:id,nombre_paciente:nombre});
	}


	cargar_cantidad_de_pacientes=()=>{


		
		Axios.get(`${Url.url_base}/api/cantidad_de_pacientes`).then(data=>{

			this.setState({cantidad_de_pacientes:data.data.cantidad_pacientes});
			//console.log(data.data.cantidad_pacientes);
		
		}).catch(erro=>{

			alertify.message("Error cargando cantidad de pacientes");
		});

	}

	buscarPaciente = (e) => {
		const termino = (e.target.value || '').trim();
		this.setState({ terminoBusqueda: e.target.value });

		if (!termino) {
			this.setState({ enBusqueda: false, clientesBusqueda: [], paginaActual: 1 }, () => {
				this.cargar_citas(1);
			});
			return;
		}

		Axios.get(`${Url.url_base}/api/buscar_paciente/${encodeURIComponent(termino)}`).then(data => {
			const elementos_nuevos = this.normalizarPacientes(data.data);
			const ultimaPagina = Math.max(1, Math.ceil(elementos_nuevos.length / REGISTROS_POR_PAGINA));

			this.setState({
				enBusqueda: true,
				clientesBusqueda: elementos_nuevos,
				clientes: [],
				paginaActual: 1,
				ultimaPagina,
				totalPacientes: elementos_nuevos.length
			});
		}).catch(error => {
			console.log(error);
		});
	}

	renderPaginador = (extraClass = '') => (
		<Paginador
			className={extraClass}
			paginaActual={this.state.paginaActual}
			ultimaPagina={this.state.ultimaPagina}
			total={this.state.totalPacientes}
			registrosPorPagina={REGISTROS_POR_PAGINA}
			cargando={this.state.cargandoPacientes}
			enBusqueda={this.state.enBusqueda}
			onIrAPagina={this.irAPagina}
		/>
	)

	formatearFecha = (fecha) => {
		if (!fecha) return '—';
		try {
			return new Date(fecha).toLocaleDateString('es-DO');
		} catch (_) {
			return fecha;
		}
	};

	inicialesPaciente = (nombre, apellido) => {
		const n = (nombre || '').trim().charAt(0).toUpperCase();
		const a = (apellido || '').trim().charAt(0).toUpperCase();
		return (n + a) || '?';
	};

	onErrorFotoPaciente = (pacienteId) => {
		this.setState((prev) => ({
			fotosFallidas: { ...prev.fotosFallidas, [pacienteId]: true }
		}));
	};

	renderAvatarPaciente = (paciente) => {
		const iniciales = this.inicialesPaciente(paciente.nombre, paciente.apellido);
		const urlFoto = Url.url_storage_publico(paciente.foto_paciente);
		const mostrarFoto = urlFoto && !this.state.fotosFallidas[paciente.id];

		if (mostrarFoto) {
			return (
				<img
					src={urlFoto}
					alt={`${paciente.nombre || ''} ${paciente.apellido || ''}`.trim()}
					className="listado-pacientes-avatar listado-pacientes-avatar--foto"
					onError={() => this.onErrorFotoPaciente(paciente.id)}
				/>
			);
		}

		return <span className="listado-pacientes-avatar">{iniciales}</span>;
	};

	cargar=(id,id_doct,foto_paciente)=>{


				this.setState({perfil_selec:true,id_cliente:id,id_doctor:id_doct,foto_paciente:foto_paciente});

	}

	actualizar_paciente(id){

		this.setState({perfil_selec:'actualizar_paciente',id_paciente:id});
	}

	leer_deuda(deuda){

		
		if(deuda>0){
			
			return {color:"#ef0808"}
		
		}else{

			return {color:"#6096e6"}

		}

		
	}


	render(){
		//let cargar_deudas =<td id={"interfaz"+data.id}>Url.Consultar_deuda_de_paciente(data.id)</td>;


		if(this.state.perfil_selec==true){

				return <PerfilPaciente id_paciente={this.state.id_cliente} IdDoctor={this.state.id_doctor} foto_paciente={this.state.foto_paciente} />;

		}else if(this.state.perfil_selec=="agregar_citas"){

			return <AgregarCita paciente={this.state.nombre_paciente} id_paciente={this.state.id_cliente}/>;

		}else if(this.state.clientes==""){
		
				console.log("no hay resultados de este paciente");

		}else if(this.state.perfil_selec=="actualizar_paciente"){

				return <ActualizarPerfil IdPaciente={this.state.id_paciente}/>;
		}
		const lang = Url.lenguaje.citas_c || {};
		const visibles = this.getPacientesVisibles();

		return (
			<div className="col-12 col-md-10 listado-pacientes-page">
				<div className="listado-pacientes-hero">
					<div className="listado-pacientes-hero-info">
						<div className="listado-pacientes-hero-icon">
							<i className="fas fa-users" />
						</div>
						<div>
							<h1 className="listado-pacientes-hero-title">Gestión de pacientes</h1>
							<p className="listado-pacientes-hero-subtitle">
								Administra y busca pacientes del sistema
							</p>
							<div className="listado-pacientes-hero-meta">
								<span>
									<i className="fas fa-procedures" />
									{' '}{this.state.procedimientos_hechos || 0} {lang.cantidad_de_procedimiento || 'procedimientos'}
								</span>
								<span>·</span>
								<span>{this.dia_actual()}</span>
							</div>
						</div>
					</div>

					{Url.puedeExportarPacientesCsv() && (
						<div className="listado-pacientes-hero-export">
							<button
								type="button"
								className="listado-pacientes-export-btn"
								onClick={this.exportarCsv}
								disabled={this.state.exportandoCsv}
							>
								{this.state.exportandoCsv ? (
									<><i className="fas fa-spinner fa-spin" /> Exportando…</>
								) : (
									<><i className="fas fa-file-csv" /> Exportar CSV</>
								)}
							</button>
						</div>
					)}

					<div className="listado-pacientes-total-card">
						<div className="listado-pacientes-total-icon">
							<i className="fas fa-user-check" />
						</div>
						<div className="listado-pacientes-total-content">
							<div className="listado-pacientes-total-label">Total registrados</div>
							<div className="listado-pacientes-total-num">
								{new Intl.NumberFormat('es-DO').format(this.state.cantidad_de_pacientes || 0)}
							</div>
						</div>
					</div>
				</div>

				<div className="listado-pacientes-search-card">
					<div className="listado-pacientes-search-wrap">
						<div className="listado-pacientes-search-icon">
							<i className="fas fa-search" />
						</div>
						<input
							type="text"
							id="buscar_paciente"
							className="form-control listado-pacientes-search-input"
							placeholder={lang.buscar_paciente || 'Buscar por nombre, apellido, cédula o teléfono…'}
							value={this.state.terminoBusqueda}
							onChange={this.buscarPaciente}
						/>
					</div>
				</div>

				<div className="listado-pacientes-table-card">
					<div className="listado-pacientes-paginador">{this.renderPaginador()}</div>
					<div className="table-responsive">
						<table className="table table-hover mb-0 listado-pacientes-table">
							<thead>
								<tr>
									<th style={{ width: '52px' }} />
									<th>#</th>
									<th>{lang.nombre || 'Nombre'}</th>
									<th>{lang.apellido || 'Apellido'}</th>
									<th>{lang.doctor || 'Doctor'}</th>
									<th>{lang.cedula || 'Cédula'}</th>
									<th>{lang.telefono || 'Teléfono'}</th>
									<th style={{ textAlign: 'right' }}>{lang.deuda || 'Deuda'}</th>
									<th>Ingreso</th>
									<th style={{ textAlign: 'center' }}>Acciones</th>
								</tr>
							</thead>
							<tbody>
								{this.state.cargandoPacientes && (
									<tr>
										<td colSpan="10" className="text-center py-5">
											<img src={Loading} alt="Cargando" style={{ width: '48px' }} />
										</td>
									</tr>
								)}
								{!this.state.cargandoPacientes && visibles.length === 0 && (
									<tr>
										<td colSpan="10" className="listado-pacientes-empty">
											<i className="fas fa-inbox" />
											No hay pacientes para mostrar
										</td>
									</tr>
								)}
								{!this.state.cargandoPacientes && visibles.map((p, index) => {
									const fila = (this.state.paginaActual - 1) * REGISTROS_POR_PAGINA + index + 1;
									const deuda = p.estatus_precio_estatus_sum || 0;
									return (
										<tr key={p.id || index}>
											<td style={{ padding: '12px 8px', width: '52px' }}>
												{this.renderAvatarPaciente(p)}
											</td>
											<td style={{ color: '#94a3b8', fontWeight: 500 }}>{fila}</td>
											<td>
												<div className="listado-pacientes-nombre-cell">{p.nombre || ''}</div>
											</td>
											<td>{p.apellido || ''}</td>
											<td style={{ color: '#64748b', fontSize: '14px' }}>
												<i className="fas fa-user-md me-1" style={{ color: '#667eea', opacity: 0.7 }} />
												{p.doctor ? `${p.doctor.nombre} ${p.doctor.apellido || ''}`.trim() : '—'}
											</td>
											<td style={{ color: '#64748b' }}>{p.cedula || '—'}</td>
											<td style={{ color: '#64748b' }}>{p.telefono || '—'}</td>
											<td style={{ textAlign: 'right' }}>
												<span className={`listado-pacientes-deuda-badge ${deuda > 0 ? 'listado-pacientes-deuda-badge--deuda' : 'listado-pacientes-deuda-badge--ok'}`}>
													${new Intl.NumberFormat('es-DO').format(deuda)}
												</span>
											</td>
											<td style={{ color: '#94a3b8', fontSize: '13px' }}>
												{this.formatearFecha(p.fecha_de_ingreso)}
											</td>
											<td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
												<Link
													to={`/perfil_paciente/${p.id}/${p.id_doctor}`}
													title={lang.ver_perfil || 'Ver perfil'}
													className="listado-pacientes-accion listado-pacientes-accion--perfil"
												>
													<i className="fa-solid fa-user-circle" />
												</Link>
												<button
													type="button"
													title={lang.asigar_cita || 'Asignar cita'}
													className="listado-pacientes-accion listado-pacientes-accion--cita"
													style={{ border: 'none', cursor: 'pointer' }}
													onClick={() => this.asignar_cita(p.id, p.nombre)}
												>
													<i className="fa-solid fa-calendar-plus" />
												</button>
												<Link
													to={`/actualizar_paciente/${p.id}`}
													title={lang.actualizar || 'Actualizar'}
													className="listado-pacientes-accion listado-pacientes-accion--editar"
												>
													<i className="fa-solid fa-pen-to-square" />
												</Link>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					<div className="listado-pacientes-paginador">{this.renderPaginador()}</div>
				</div>
			</div>
		);


	}


}

export default Cita;